/** Shared saga helpers for sandbox module. */
export function settle(
    resolve: ((v: any) => void) | undefined,
    reject: ((e: any) => void) | undefined,
    value: any,
    isError = false,
) {
    if (isError) {
        if (typeof reject === 'function') reject(value);
        return;
    }
    if (typeof resolve === 'function') resolve(value);
}

export function asBookingList(res: any): any[] {
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.data)) return res.data;
    return [];
}
